import Rudderstack from 'utils/Rudderstack';

const trackEvent = ({ eventCategory, eventAction, eventLabel, eventValue = '' }) => {
  return {
    hitType: 'event',
    eventCategory,
    eventAction,
    eventLabel,
    eventValue,
  };
};

const trackCTAClickEvent = ({ payload }) => {
  const {
    type,
    location,
    name,
    url,
    value,
    copy,
    campaignName,
    experienceName,
    variationName,
    variationId,
  } = payload;

  Rudderstack.callToActionClicked({
    type,
    location,
    name,
    url,
    value,
    copy,
    campaignName,
    experienceName,
    variationName,
    variationId,
  });
};

export { trackEvent, trackCTAClickEvent };
